"use strict";

require("core-js/modules/es7.symbol.async-iterator");
require("core-js/modules/es6.symbol");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.array.from");
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.regexp.to-string");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'popup',
  components: {},
  data: function data() {
    return {
      statusArr: ['在槽', '借出中', '已借出', '异常'],
      baoList: [],
      cangArr: [],
      type: this.$route.query.type || 1
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    /**
     * 获取设备信息
     */
    getList: function getList() {
      var _this = this;
      this.$get('agentapi/device/get_zuo_status1', {
        goods_sn: this.$route.params.goods_sn
      }).then(function (res) {
        _this.baoList = res;
      });
    },
    getStatusText: function getStatusText(status) {
      switch (status) {
        case 0:
          return '无充电宝';
        case 1:
          return '正常';
        case 2:
          return '充电宝充电不正常';
        case 3:
          return '无法读取充电宝sn';
      }
    },
    getNoTextZCM: function getNoTextZCM(no) {
      return "".concat(no);
    },
    getNoText: function getNoText(aims, no) {
      var arr = ['--', '右上', '右下', '左下', '左上'];
      return "".concat(aims, "\u5C42-").concat(arr[no]);
    },
    getPowerText: function getPowerText(item) {
      if (item.status === 1) {
        return "".concat(item.power * 10, "% - ").concat(item.power * 10 + 10, "%");
      } else {
        return '--';
      }
    },
    /**
     * 弹出设备
     */
    ejectEquip: function ejectEquip(row) {
      var _this2 = this;
      this.loadObj = this.$loading({
        lock: true,
        text: '弹出中~~~',
        spinner: 'el-icon-loading'
      });
      if (row) {
        //if (row.status === 1) {
        this.$post('agentapi/device/eject_bao1', {
          zuo_sn: this.$route.params.goods_sn,
          cang_num: [{
            aims: row.aims,
            no: row.no
          }]
        }).then(function (res) {
          _this2.loadObj.close();
          _this2.$message({
            message: '弹出成功',
            type: 'success'
          });
          setTimeout(function () {
            _this2.getList();
          }, 1000);
        }).catch(function (err) {
          _this2.loadObj.close();
        });

        //}
      } else {
        var _iterator = _createForOfIteratorHelper(this.baoList),
          _step;
        try {
          var _loop = function _loop() {
            var item = _step.value;
            //if (item.status === 1) {

            setTimeout(function () {
              _this2.$post('agentapi/device/eject_bao1', {
                zuo_sn: _this2.$route.params.goods_sn,
                cang_num: [{
                  aims: item.aims,
                  no: item.no
                }]
              }).then(function (res) {
                _this2.loadObj.close();
                _this2.$message({
                  message: '弹出成功',
                  type: 'success'
                });
                setTimeout(function () {
                  _this2.getList();
                }, 1000);
              }).catch(function (err) {
                _this2.loadObj.close();
              });
            }, 1000 * item.no);
            //}
          };
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      //if (cang_num.length == 0) {
      //  this.$message({
      //    message: '暂无可弹出的设备',
      //   type: 'error'
      // })
      // return
      // }
    },
    /**
     * 设备锁定 或  解锁
     */
    locked: function locked(row) {
      var _this3 = this;
      var agree = row.is_locked == 1 ? 0 : 1;
      this.$post('agentapi/device/lock_rent', {
        goods_sn: row.zuo_sn,
        bao_id: row.bao_id,
        agree: agree
      }).then(function (res) {
        _this3.$message({
          message: '设置成功',
          type: 'success'
        });
        row.is_locked = agree;
      });
    },
    /**
     * 绑定 或  解绑
     */
    binded: function binded(row) {
      var _this4 = this;
      var binded_status = row.binded_status == 1 ? 0 : 1;
      this.$post('agentapi/device/bind_bao', {
        zuo_sn: row.zuo_sn,
        bao_sn: row.bao_sn,
        binded_status: binded_status
      }).then(function (res) {
        _this4.$message({
          message: '设置成功',
          type: 'success'
        });
        row.binded_status = binded_status;
      });
    }
  }
};